define('views/parts/panel/panel-header',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    'services/i18n',
    // views
    'views/parts/menu/menu',
    // templates
    'text!templates/parts/panel/panel-header.html',
    'text!templates/parts/menu/menu-panel.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    i18n,
    // views
    VMenu,
    // templates
    TPanelHeader,
    TMenuPanel
) {

    var VPanelHeader = Backbone.View.extend({
        template: TPanelHeader,
        events: {
            'click .menu-mobile-link button': 'toggleMenu'
        },

        regions: {
            menu: ".panel-buttons",
        },

        defaults: {
            close: { icon: "sl-icon-close", title: "messages:tooltip-close-panel" },
            expand: { icon: "sl-icon-arrow-left-circle btn-expand", title: "Expand panel" },
            back: { icon: "sl-icon-arrow-left-circle", title: "Back" },
        },

        initialize: function(opt) {
            var options = this.options = opt || {};

            var collection = this.collection = new Backbone.Collection(options.buttons),
                defaults = this.defaults;

            this.defaults.close.title = i18n.t("messages:tooltip-close-panel");

            this.addButton(options.expand, defaults.expand)
                .addButton(options.close, defaults.close)
                .addButton(options.back, defaults.back);

            this.view = {
                menu: new VMenu({
                    templateItem: TMenuPanel,
                    collection: collection,
                    context: options.context
                })
            };

            this.model = new Backbone.Model({
                title: options.title,
                subtitle: options.subtitle,
                specificTitle: options.specificTitle,
                skipTranslation: options.skipTranslation
            });

            this.listenTo(this.model, 'change', this.render);
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(this.model.toJSON()));
            this.$el.empty().append(html);

            this.generateZones()
                .assign(this.view.menu, this.zone.$menu);

            return this;
        },

        addButton: function(button, defaults) {
            if (button) {
                if (_.isObject(button)) {
                    button = _.extend({}, defaults, button);
                } else {
                    button = _.defaults({ callback: button }, defaults);
                }
                this.collection.add(button);
            }
            return this;
        },

        toggleMenu: function(e) {
            e.preventDefault();
            LayoutState.toggleMenu();
        },

        setTitle: function(title) {
            this.model.set('title', title);
        },

        setSubtitle: function(subtitle) {
            this.model.set('subtitle', subtitle);
        },

        setSpecificTitle: function(specific) {
            this.model.set('specificTitle', specific);
        },

        setSkipTranslation: function(skipTranslation) {
            this.model.set('skipTranslation', skipTranslation);
        }

    });

    return VPanelHeader;

});

